"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const styles_1 = require("@mui/material/styles");
const BaseButton_1 = __importDefault(require("../BaseButton"));
const shared_styles_1 = require("../common/shared-styles");
const StyledButton = (0, styled_components_1.default)(BaseButton_1.default) `
  color: ${({ theme }) => theme.palette.common.white};
  background-color: ${({ theme }) => theme.palette.primary.main};
  padding: 16px 24px;
  border-radius: ${({ theme }) => theme.constants.borderRadius};
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.14),
    0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 3px 0 rgba(0, 0, 0, 0.2);

  &:after {
    border-radius: ${({ theme }) => theme.constants.borderRadius};
  }

  &:hover {
    background-color: ${({ theme }) => theme.palette.blue[70]};
  }

  &:active {
    background-color: ${({ theme }) => theme.palette.primary.main};
  }

  ${shared_styles_1.defaultFocusStyles}

  &.Mui-disabled:disabled {
    pointer-events: auto;
    background-color: ${({ theme }) => theme.palette.gray[10]};
    box-shadow: none;
  }
`;
/**
 * _Primary Button_
 *
 * The primary button guides the user to the primary call to action. It can be used independently of the secondary button.
 * When paired with a secondary button, it should be placed on the right.
 *
 * **Scaling for responsive screen size:**
 * The primary button will fill the container space.
 * The top and bottom padding of text is fixed at 16pt. Text must never exceed one line.
 */
const Primary = (props) => {
    const theme = (0, styles_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)(StyledButton, { touchRippleColor: props.touchRippleColor || theme.palette.blue[80], ...props }));
};
exports.default = Primary;
//# sourceMappingURL=index.js.map